import axios from './axios';

export type McpEndpoint = {
  id: string;
  name: string;
  scopes: string[];
  path: string;
  shared: boolean;
  createdBy: string;
  createdAt: string;
};

export type CreateMcpEndpointRequest = {
  name: string;
  scopes: string[];
  shared: boolean;
};

export type McpOrganizationSettings = {
  mcpEnabled: boolean;
};

export const getMcpSettings = async () => {
  const { data } = await axios.get<McpOrganizationSettings>('/api/McpEndpoint/Settings');
  return data;
};

export const setMcpEnabled = async (enabled: boolean) => {
  const { data } = await axios.post<McpOrganizationSettings>('/api/McpEndpoint/SetEnabled', { enabled });
  return data;
};

export const getMcpEndpoints = async () => {
  const { data } = await axios.get<McpEndpoint[]>('/api/McpEndpoint/List');
  return data;
};

export const createMcpEndpoint = async (request: CreateMcpEndpointRequest) => {
  const { data } = await axios.post<McpEndpoint>('/api/McpEndpoint/Create', request);
  return data;
};

export const deleteMcpEndpoint = async (id: string) => {
  await axios.post('/api/McpEndpoint/Delete', { id });
};
